<div class="time-lapse-container" #container></div>
